import { Api } from '../axiosApi';

// Confere no backend (banco mestre, ver EnsureControleAdmin.ts) se o usuário logado tem
// `controle = true` no cadastro. Não decodifica nada do token — a verificação é sempre
// feita direto no cadastro do usuário, no servidor.
const verificar = async (): Promise<boolean> => {
  try {
    await Api.get('/controle/verificar');
    return true;
  } catch {
    return false;
  }
};

export const AcessoControleService = {
  verificar,
};
